/**
 * ページ送りの一覧で、今のページが無くなったときの戻り方。
 *
 * #387 の Codex の指摘 4368575053（RV-702）で運営の画面に作ったものを、既存の一覧（機器・車両・運転者・
 * 測定・勤怠・車両の点検・運転者の詳細の表・ダッシュボードの最近の提出）でも使うために、ここへ移した（EV-460）。
 */

/**
 * 今のページが無くなったときに戻るページ。
 * - 読んだページが 404（ページの外。最後のページの1件を消した後に、別の人の操作で件数が減ったときなど）なら1ページ目。
 * - 読めたが空で、全体には件数があるなら、最後の有効なページ（ceil(count / pageSize)）。
 * どちらでもなければ null（今のページのまま）。
 */
export function pageToRecover(
  page: number,
  pageSize: number,
  result: { error?: unknown; count?: number; rows?: number }
): number | null {
  if (page <= 1) return null;
  const status = (result.error as { response?: { status?: number } } | undefined)?.response?.status;
  if (result.error !== undefined) return status === 404 ? 1 : null;
  if (result.rows === 0 && (result.count ?? 0) > 0) {
    const last = Math.max(1, Math.ceil((result.count ?? 0) / pageSize));
    // 今のページより前のときだけ戻る（同じページを読み直し続けない）。
    return last < page ? last : null;
  }
  return null;
}

/** 一覧から1件が消える操作（外す・削除）の後に読むページ。今のページの最後の1件なら、1つ前のページ。 */
export const pageAfterRemoval = (page: number, rowsOnPage: number): number =>
  rowsOnPage <= 1 && page > 1 ? page - 1 : page;
